import React, { act } from "react";
import SecondaryButton from "../buttons/SecondaryButton";

import { useSnackbar } from "notistack";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgById } from "../models/OrgFunctions";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { useAppContext } from "../config/AppContext";
import PrimaryButton from "../buttons/PrimaryButton";
import TextField2 from "../textfields/TextField2";

import ConfirmationModal from "./ConfirmationModal";
import Modal1 from "./Modal1";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { EasySwitch } from "../textfields/EasySwitch";
import DropDownGPT0 from "../dropdowns/DropDownGTP0";
import { memberRoles } from "../members/MemberManager";
import { getDocDataById, getDocDataByRef } from "../models/DataFunctions";

const MemberModal = ({ onClose, orgData, user_id, onUpdate }) => {
  const [actualuserData, setActualUserData] = useState(null);
  const [actualorgData, setActualOrgData] = useState(null);
  const { currentUser, loading } = useAuth();

  const [name_value, setNameValue] = useState(null);
  const [type_value, setTypeValue] = useState(null);
  const [org_admin, setOrgAdmin] = useState(null);
  const [type_options, setTypeOptions] = useState([]);

  const [message, SetMessage] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleSaveMemberDetails = async () => {
    await updateDocDataFieldApi(
      actualuserData.ref,
      "display_name",
      name_value,
      prefix
    );
    await updateDocDataFieldApi(
      actualuserData.ref,
      "org_admin",
      org_admin,
      prefix
    );
    if (actualorgData.type !== "expert") {
      await updateDocDataFieldApi(
        actualuserData.ref,
        "role",
        type_value.value,
        prefix
      );
    }
    handleClickVariant("Membre mis à jour avec succès", "success");
    onUpdate();
    onClose();
  };

  const handleDeleteMember = async () => {
    const token = await getOrRefreshFirebaseToken();
    // await deleteMember(orgData.id, user_id, token, prefix);

    handleClickVariant("Membre supprimé avec succès", "success");
    onUpdate();
    onClose();
  };

  const handleSendInvite = async () => {
    const token = await getOrRefreshFirebaseToken();

    const senderEntreprise = orgData.name;
    const receiverEmail = actualuserData.email;
    const oid = actualorgData.id;

    // await sendInvite(
    //   user_id,
    //   senderEntreprise,
    //   receiverEmail,
    //   oid,
    //   token,
    //   prefix
    // );
    handleClickVariant("Invitation envoyée avec succès", "success");
    onUpdate();
    onClose();
  };

  const handleFetchData = async () => {
    try {
      console.log("user_id", user_id);
      const actualuser = await getDocDataById("user", user_id);
      const actualorg = orgData
        ? orgData
        : await getOrgById(actualuser.org_id);

      let option_types = memberRoles;

      setTypeOptions(option_types);
      setOrgAdmin(actualuser.org_admin);

      setActualUserData(actualuser);
      setActualOrgData(actualorg);

      setNameValue(actualuser.display_name);
      setTypeValue(
        option_types.find((type) => type.value === actualuser.role) ||
          option_types[0]
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const onDismiss = async (confirmed) => {
    if (confirmed) {
      await handleDeleteMember();
    }
    setConfirmationOpen(false);
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  if (loading || !currentUser || !actualorgData) {
    return <> Loading ..</>;
  }

  return (
    <div className="bg-white flex flex-col p-4 w-c300 rounded-3xl ">
      <Modal1
        onClose={() => setConfirmationOpen(false)}
        isOpen={confirmationOpen}
      >
        <ConfirmationModal onDismiss={onDismiss}></ConfirmationModal>
      </Modal1>

      <div className="flex flex-col gap-3 w-full">
        <div className="flex flex-row justify-between">
          {" "}
          <div className="text-h3">Modifier membre</div>
          <div
            className="text-h3 text-shadow_50 cursor-pointer"
            onClick={onClose}
          >
            Fermer
          </div>
        </div>
        <TextField2
          label="Prénom Nom"
          value={name_value}
          onChange={(e) => setNameValue(e.target.value)}
        />
        {actualorgData.type !== "expert" && (
          <DropDownGPT0
            label="Rôle"
            items={type_options}
            value={type_value}
            onChange={(e) => setTypeValue(e)}
          />
        )}
        <div className="flex flex-row gap-2 items-center">
          <EasySwitch
            checked={org_admin}
            onChange={(checked) => setOrgAdmin(checked)}
          ></EasySwitch>
          <div className="text-h3 text-shadow_50">Administrateur</div>
        </div>

        <SecondaryButton className="w-fit" onClick={handleSendInvite}>
          Renvoyer l'invitation
        </SecondaryButton>
        <div className="flex flex-row justify-between">
          <SecondaryButton
            className="w-fit"
            onClick={() => setConfirmationOpen(true)}
            disabled={actualuserData.org_admin}
          >
            Supprimer
          </SecondaryButton>
          <PrimaryButton className="w-fit" onClick={handleSaveMemberDetails}>
            Enregistrer
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default MemberModal;
